import interceptorAxios from './InterceptorAxios';
const ServicioPagos={
   
    facturar_comprobante_pago(objeto){
        return interceptorAxios.post('/pagos/facturar_pago.json',objeto);
    },
    paginacion(objeto){
        return interceptorAxios.post('/cfdi/paginacion_pagos_hijos.json',objeto);
    },

    obtner_comprobante(objeto){
        return interceptorAxios.post('/pagos/obtener_comprobante_pagos.json',objeto);
    },
    realizar_calculos_cantidad_total(objeto){
        return interceptorAxios.post('/pagos/realizar_calculos_cantidad_total.json',objeto);
    },
    facturar_comprobante(objeto){
      return interceptorAxios.post('/pagos/facturacion_comprobante_origen.json',objeto);
  },
  procesar_factura(objeto){
    return interceptorAxios.post("/pagos/subir_factura_origen.json", objeto); 
 }
  
}
export default ServicioPagos;